var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "_tag",
      class: ((_obj = {}),
      (_obj["bg-" + _vm.tone] = _vm.tone),
      (_obj["_e" + _vm.appearance] = _vm.appearance),
      _obj)
    },
    [
      _c(
        "span",
        { staticClass: "_tagi" },
        [_vm._t("default", [_vm._v("‌")])],
        2
      ),
      _vm.deletable
        ? _c(
            "ib-button",
            {
              staticClass: "link",
              attrs: {
                type: "button",
                tone: "gray",
                tabindex: "-1",
                disabled: _vm.disabled
              },
              on: {
                mousedown: function($event) {
                  $event.stopPropagation()
                },
                click: _vm.onDelete
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 50 50"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M9.16 6.31L6.3 9.16 22.16 25 6.22 40.97l2.81 2.81L25 27.84l15.94 15.94 2.84-2.84L27.84 25 43.7 9.16 40.84 6.3 25 22.16z"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }